if (!customElements.get('iamvaclav-jersey-configurator')) {
  customElements.define(
    'iamvaclav-jersey-configurator',
    class IamvaclavJerseyConfigurator extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.form = document.getElementById(this.dataset.formId);
        this.productRoot = this.closest('product-info') || document;
        this.modeInputs = [...this.querySelectorAll('[data-jersey-mode]')];
        this.captaincyInputs = [...this.querySelectorAll('[data-jersey-captaincy]')];
        this.signatureInputs = [...this.querySelectorAll('[data-jersey-signature]')];
        this.colorInputs = [];
        this.jerseyTypeInputs = [];
        this.sizeInputs = [];
        this.sizeField = null;
        this.submitButton = null;
        this.submitButtonText = null;
        this.jerseyTypeChosen = false;
        this.jerseyColorChosen = false;
        this.jerseySizeChosen = false;
        this.variantChoiceInitialized = false;
        this.personalizationLocked = false;
        this.colorField = null;
        this.priceBlock = null;
        this.buyButtons = null;
        this.playerField = this.querySelector('[data-jersey-player-field]');
        this.playerSelect = this.querySelector('[data-jersey-player]');
        this.customFields = this.querySelector('[data-jersey-custom-fields]');
        this.captaincyField = this.querySelector('[data-jersey-captaincy-field]');
        this.signaturePlayerField = this.querySelector('[data-jersey-signature-player-field]');
        this.signaturePlayerSelect = this.querySelector('[data-jersey-signature-player]');
        this.customName = this.querySelector('[data-jersey-custom-name]');
        this.customNumber = this.querySelector('[data-jersey-custom-number]');
        this.modeProperty = this.querySelector('[data-jersey-mode-property]');
        this.nameProperty = this.querySelector('[data-jersey-name-property]');
        this.numberProperty = this.querySelector('[data-jersey-number-property]');
        this.captaincyProperty = this.querySelector('[data-jersey-captaincy-property]');
        this.signatureProperty = this.querySelector('[data-jersey-signature-property]');
        this.signaturePlayerProperty = this.querySelector('[data-jersey-signature-player-property]');
        this.signatureItemId = this.querySelector('[data-jersey-signature-item-id]');
        this.signatureItemQuantity = this.querySelector('[data-jersey-signature-item-quantity]');
        this.signatureItemParentId = this.querySelector('[data-jersey-signature-item-parent-id]');
        this.currentVariant = this.selectedVariant();
        this.previewImage = this.productRoot.querySelector('[data-jersey-preview-image]');
        this.previewOptions = [...this.productRoot.querySelectorAll('[data-jersey-preview-option]')];
        this.preview = this.productRoot.querySelector('[data-jersey-preview]');
        this.previewName = this.productRoot.querySelector('[data-jersey-preview-name]');
        this.previewNumber = this.productRoot.querySelector('[data-jersey-preview-number]');
        this.error = this.querySelector('[data-jersey-error]');
        this.nameMaxLength = Number.parseInt(this.dataset.nameMaxLength, 10) || 20;
        this.numberMaxLength = Number.parseInt(this.dataset.numberMaxLength, 10) || 2;
        this.hasPlayerOptions = Boolean(
          this.playerSelect?.querySelector('option[data-player-name][data-player-number]')
        );

        this.sync = this.sync.bind(this);
        this.validate = this.validate.bind(this);
        this.handlePreviewOptionClick = this.handlePreviewOptionClick.bind(this);
        this.handleProductOptionChange = this.handleProductOptionChange.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);

        this.modeInputs.forEach((input) => input.addEventListener('change', this.sync));
        this.captaincyInputs.forEach((input) => input.addEventListener('change', this.sync));
        this.signatureInputs.forEach((input) => input.addEventListener('change', this.sync));
        this.playerSelect?.addEventListener('change', this.sync);
        this.signaturePlayerSelect?.addEventListener('change', this.sync);
        this.customName?.addEventListener('input', this.sync);
        this.customNumber?.addEventListener('input', this.sync);
        this.previewOptions.forEach((option) => option.addEventListener('click', this.handlePreviewOptionClick));
        this.form?.addEventListener('submit', this.validate, true);
        this.productRoot?.addEventListener('change', this.handleProductOptionChange, true);
        if (window.MutationObserver && this.productRoot) {
          this.variantChoiceObserver = new MutationObserver(() => {
            if (this.initialized) this.syncVariantChoiceLock(true);
          });
          this.variantChoiceObserver.observe(this.variantControlsRoot().parentElement || this.productRoot, { childList: true });
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
        }

        this.refreshColorInputs();
        this.refreshVariantChoiceInputs();
        this.rememberUnavailableConfiguratorOptions();
        this.clearInitialVariantChoice();
        this.syncVariantChoiceLock();
        this.sync();
      }

      disconnectedCallback() {
        this.modeInputs?.forEach((input) => input.removeEventListener('change', this.sync));
        this.captaincyInputs?.forEach((input) => input.removeEventListener('change', this.sync));
        this.signatureInputs?.forEach((input) => input.removeEventListener('change', this.sync));
        this.playerSelect?.removeEventListener('change', this.sync);
        this.signaturePlayerSelect?.removeEventListener('change', this.sync);
        this.customName?.removeEventListener('input', this.sync);
        this.customNumber?.removeEventListener('input', this.sync);
        this.previewOptions?.forEach((option) => option.removeEventListener('click', this.handlePreviewOptionClick));
        this.form?.removeEventListener('submit', this.validate, true);
        this.productRoot?.removeEventListener('change', this.handleProductOptionChange, true);
        this.variantChoiceObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
        this.initialized = false;
      }

      get selectedMode() {
        const selectedMode = this.modeInputs.find((input) => input.checked && input.dataset.jerseyUnavailable !== 'true');
        return selectedMode?.value || (this.hasPlayerOptions ? 'player' : 'custom');
      }

      get isCustom() {
        return this.selectedMode === 'custom';
      }

      get isPlayer() {
        return this.selectedMode === 'player';
      }

      sync() {
        this.clearError();

        if (this.customNumber) {
          this.customNumber.value = this.customNumber.value
            .replace(/\D/g, '')
            .replace(/^0+(?=\d)/, '')
            .slice(0, this.numberMaxLength);
        }

        if (!this.hasPlayerOptions) {
          const playerMode = this.modeInputs.find((input) => input.value === 'player');
          const customMode = this.modeInputs.find((input) => input.value === 'custom');
          if (playerMode) playerMode.disabled = true;
          if (customMode) customMode.checked = true;
        }

        this.toggleModeFields();

        if (this.isCustom) {
          const name = this.customName?.value.trim() || '';
          const number = this.customNumber?.value.trim() || '';
          const captaincy = this.selectedCaptaincy();
          if (this.modeProperty) this.modeProperty.value = 'Vlastní jméno a číslo';
          if (this.nameProperty) this.nameProperty.value = name;
          if (this.numberProperty) this.numberProperty.value = number;
          this.setFormField(this.captaincyProperty, captaincy, !captaincy);
          this.updatePreview(name, number);
          this.syncSignature();
          return;
        }

        const selectedPlayer = this.selectedRosterPlayer();
        const name = selectedPlayer?.dataset.playerName || '';
        const number = selectedPlayer?.dataset.playerNumber || '';
        if (this.modeProperty) this.modeProperty.value = 'Soupiska';
        if (this.nameProperty) this.nameProperty.value = name;
        if (this.numberProperty) this.numberProperty.value = number;
        this.setFormField(this.captaincyProperty, '', true);
        this.updatePreview(name, number);
        this.syncSignature();
      }

      selectedCaptaincy() {
        const selectedCaptaincy = this.captaincyInputs.find((input) => input.checked);

        return selectedCaptaincy?.value || '';
      }

      selectedSignatureInput() {
        return this.signatureInputs.find((input) => input.checked && input.dataset.jerseyUnavailable !== 'true');
      }

      selectedRosterPlayer() {
        return this.playerSelect?.selectedOptions?.[0];
      }

      selectedSignaturePlayerName() {
        if (this.isPlayer) return this.selectedRosterPlayer()?.dataset.playerName || '';

        const selectedPlayer = this.signaturePlayerSelect?.selectedOptions?.[0];

        return selectedPlayer?.dataset.playerName || '';
      }

      currentVariantId() {
        return this.productRoot.querySelector('.product-variant-id')?.value || this.form?.querySelector('[name="id"]')?.value || '';
      }

      setFormField(input, value, disabled) {
        if (!input) return;

        input.value = value;
        input.disabled = disabled;
      }

      syncSignature() {
        const selectedSignature = this.selectedSignatureInput();
        const signatureValue = selectedSignature?.value || '';
        const variantId = selectedSignature?.dataset.signatureVariantId || '';
        const needsPlayer = selectedSignature?.dataset.signatureRequiresPlayer === 'true';
        const signatureLabel =
          signatureValue === 'single' ? 'Podpis hráče' : signatureValue === 'team' ? 'Podpis celého týmu' : '';
        const playerName = needsPlayer ? this.selectedSignaturePlayerName() : '';
        const hasSignature = Boolean(signatureLabel && variantId);
        const showSignaturePlayerField = needsPlayer && !this.isPlayer;

        this.signatureInputs.forEach((input) => {
          input.disabled = this.personalizationLocked || input.dataset.jerseyUnavailable === 'true';
        });
        if (this.signaturePlayerField) this.signaturePlayerField.hidden = !showSignaturePlayerField;
        if (this.signaturePlayerSelect) this.signaturePlayerSelect.disabled = this.personalizationLocked || !showSignaturePlayerField;

        this.setFormField(this.signatureProperty, signatureLabel, !hasSignature);
        this.setFormField(this.signaturePlayerProperty, playerName, !(hasSignature && needsPlayer && playerName));
        this.setFormField(this.signatureItemId, variantId, !hasSignature);
        this.setFormField(this.signatureItemQuantity, '1', !hasSignature);
        this.setFormField(this.signatureItemParentId, this.currentVariantId(), !hasSignature);
        this.syncPrice(selectedSignature);
      }

      selectedVariant() {
        try {
          return JSON.parse(this.productRoot.querySelector('variant-selects [data-selected-variant]')?.textContent || 'null');
        } catch {
          return null;
        }
      }

      variantPriceAmount() {
        const price = this.currentVariant?.price ?? this.selectedVariant()?.price;

        return Number.isFinite(Number(price)) ? Number(price) : null;
      }

      signaturePriceAmount(selectedSignature) {
        const rawAmount = selectedSignature?.dataset.signaturePriceAmount || '';
        const variantAmount = Number.parseInt(rawAmount, 10);
        if (Number.isFinite(variantAmount)) return variantAmount;

        const label = selectedSignature?.dataset.signaturePriceLabel || '';
        const compactLabel = label.replace(/\s/g, '').replace(/[^\d,.-]/g, '');
        if (!compactLabel) return 0;

        const amount = Number.parseFloat(compactLabel.replace(',', '.'));

        return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
      }

      formatMoney(amount) {
        const hasDecimals = amount % 100 !== 0;

        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'cs-CZ', {
            style: 'currency',
            currency: this.productRoot.querySelector('variant-selects')?.dataset.currencyCode || 'CZK',
            minimumFractionDigits: hasDecimals ? 2 : 0,
            maximumFractionDigits: hasDecimals ? 2 : 0,
          }).format(amount / 100);
        } catch {
          return `${Math.round(amount / 100).toLocaleString('cs-CZ')} Kč`;
        }
      }

      syncPrice(selectedSignature) {
        if (!this.signatureInputs.length) return;

        const basePrice = this.variantPriceAmount();
        if (!Number.isFinite(basePrice)) return;

        const priceText = this.formatMoney(basePrice + this.signaturePriceAmount(selectedSignature));
        this.productRoot
          .querySelectorAll(
            "[id^='price-'] .price__regular .price-item--regular, [id^='price-'] .price__sale .price-item--sale"
          )
          .forEach((priceItem) => {
            if (priceItem.textContent === priceText) return;

            priceItem.textContent = priceText;
          });
      }

      selectedColor() {
        this.refreshColorInputs();
        const value = this.colorInputs.find((input) => input.checked)?.value || '';

        return this.colorFromValue(value);
      }

      colorFromValue(value) {
        value = value.toLowerCase();
        if (value.includes('červen') || value.includes('cerven') || value.includes('red')) return 'red';
        if (value.includes('bíl') || value.includes('bil') || value.includes('white')) return 'white';
        return '';
      }

      updatePreview(name, number) {
        this.updatePreviewImage();
        if (this.previewName) this.previewName.textContent = name ? name.toUpperCase() : '';
        if (this.previewNumber) this.previewNumber.textContent = number || '';
      }

      selectedPreviewView() {
        return this.isCustom || this.isPlayer ? 'back' : 'front';
      }

      imageSources() {
        const dataset = this.previewImage?.dataset || {};
        const fallback = dataset.jerseyFallbackSrc || '';

        return {
          white: {
            front: dataset.jerseyWhiteFrontSrc || fallback,
            back: dataset.jerseyWhiteBackSrc || dataset.jerseyWhiteFrontSrc || fallback,
          },
          red: {
            front: dataset.jerseyRedFrontSrc || fallback,
            back: dataset.jerseyRedBackSrc || dataset.jerseyRedFrontSrc || fallback,
          },
        };
      }

      defaultPreviewColor() {
        const sources = this.imageSources();
        if (sources.white.front || sources.white.back) return 'white';
        if (sources.red.front || sources.red.back) return 'red';
        return '';
      }

      previewImageSource(color, view) {
        const sources = this.imageSources();
        const selectedSources = sources[color] || {};

        return selectedSources[view] || selectedSources.front || this.previewImage?.dataset.jerseyFallbackSrc || '';
      }

      updatePreviewImage() {
        if (!this.previewImage) return;

        const color = this.selectedColor() || this.defaultPreviewColor();
        const view = this.selectedPreviewView();
        const src = this.previewImageSource(color, view);
        if (!src) return;

        this.setPreviewImage(color, view, src);
      }

      setPreviewImage(color, view, src) {
        if (!this.previewImage || !src) return;

        if (this.previewImage.getAttribute('src') !== src) {
          this.previewImage.setAttribute('src', src);
          this.previewImage.removeAttribute('srcset');
        }
        this.previewImage.dataset.jerseyActiveColor = color;
        this.previewImage.dataset.jerseyActiveView = view;
        if (this.preview) {
          this.preview.dataset.jerseyColor = color;
          this.preview.dataset.jerseyView = view;
        }
        this.updatePreviewOptionState(color, view, src);
      }

      updatePreviewOptionState(color, view, src) {
        this.previewOptions?.forEach((option) => {
          const isActive =
            option.dataset.jerseyPreviewSrc === src ||
            (option.dataset.jerseyPreviewColor === color && option.dataset.jerseyPreviewView === view);

          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      handlePreviewOptionClick(event) {
        const option = event.currentTarget;
        const color = option?.dataset?.jerseyPreviewColor || this.selectedColor() || this.defaultPreviewColor();
        const view = option?.dataset?.jerseyPreviewView || 'front';
        const src = option?.dataset?.jerseyPreviewSrc || this.previewImageSource(color, view);

        this.setPreviewImage(color, view, src);
      }

      handleProductOptionChange(event) {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;

        this.clearError();

        if (this.isJerseyTypeInput(target)) {
          this.jerseyTypeChosen = true;
          this.jerseyColorChosen = false;
          this.jerseySizeChosen = false;
        }

        if (this.isColorInput(target)) {
          this.jerseyColorChosen = true;
          this.jerseySizeChosen = false;
        }

        if (this.isSizeInput(target)) {
          this.jerseySizeChosen = true;
        }

        if (this.isJerseyTypeInput(target) || this.isColorInput(target) || this.isSizeInput(target)) {
          this.syncVariantChoiceLock();
        }

        if (!this.isColorInput(target)) return;

        this.refreshColorInputs();
        this.sync();
      }

      handleVariantChange(event) {
        this.currentVariant = event?.data?.variant || this.selectedVariant();
        this.refreshColorInputs();
        this.sync();
        this.syncVariantChoiceLock(true);
      }

      refreshVariantChoiceInputs() {
        const controlsRoot = this.variantControlsRoot();
        this.jerseyTypeInputs = [
          ...controlsRoot.querySelectorAll(
            "[data-option-role='jersey-type'] input[type='radio'], input[data-option-name='Typ dresu']"
          ),
        ];
        this.refreshColorInputs();
        this.colorField = controlsRoot.querySelector("[data-option-role='color']");
        this.priceBlock = this.productRoot.querySelector("[id^='price-']");
        this.buyButtons = this.form?.closest('.iamvaclav-buy-buttons') || this.productRoot.querySelector('.iamvaclav-buy-buttons');
        this.sizeField = controlsRoot.querySelector('.iamvaclav-size-picker');
        this.sizeInputs = this.sizeField ? [...this.sizeField.querySelectorAll("input[type='radio']")] : [];
        this.submitButton = this.form?.querySelector("button[name='add']") || this.productRoot.querySelector("button[name='add']");
        this.submitButtonText = this.submitButton?.querySelector('span');
      }

      rememberUnavailableConfiguratorOptions() {
        [...this.modeInputs, ...this.signatureInputs].forEach((input) => {
          if (input.disabled) input.dataset.jerseyUnavailable = 'true';
        });
      }

      clearInitialVariantChoice() {
        if (this.variantChoiceInitialized || !this.jerseyTypeInputs.length || !this.sizeInputs.length) return;

        this.jerseyTypeInputs.forEach((input) => {
          input.checked = false;
        });
        this.colorInputs.forEach((input) => {
          input.checked = false;
        });
        this.sizeInputs.forEach((input) => {
          input.checked = false;
        });
        this.variantChoiceInitialized = true;
      }

      syncVariantChoiceLock(allowSubmitRestore = false) {
        this.refreshVariantChoiceInputs();
        if (!this.jerseyTypeInputs.length || !this.sizeInputs.length) return;

        if (!this.jerseyTypeChosen) {
          this.jerseyTypeInputs.forEach((input) => {
            input.checked = false;
          });
        }

        if (!this.jerseyTypeChosen || !this.jerseyColorChosen) {
          this.colorInputs.forEach((input) => {
            input.checked = false;
          });
        }

        if (!this.jerseyTypeChosen || !this.jerseyColorChosen || !this.jerseySizeChosen) {
          this.sizeInputs.forEach((input) => {
            input.checked = false;
          });
        }

        const hasType = this.jerseyTypeChosen && this.jerseyTypeInputs.some((input) => input.checked && !input.disabled);
        const hasColor = this.jerseyColorChosen && this.colorInputs.some((input) => input.checked && !input.disabled);
        const hasSize = this.jerseySizeChosen && this.sizeInputs.some((input) => input.checked && !input.disabled);
        this.updateProgressiveVisibility(hasType, hasColor, hasSize);
        this.setSizePickerLocked(!hasColor);

        if (!hasType) {
          this.blockSubmit('Vyberte typ dresu');
          return;
        }

        if (!hasColor) {
          this.blockSubmit('Vyberte barvu dresu');
          return;
        }

        if (!hasSize) {
          this.blockSubmit('Vyberte velikost');
          return;
        }

        if (allowSubmitRestore && this.currentVariant?.available !== false) {
          this.restoreSubmit();
        }
      }

      updateProgressiveVisibility(hasType, hasColor, hasSize) {
        if (this.colorField) {
          this.colorField.hidden = false;
          this.setOptionPickerLocked(this.colorField, !hasType);
        }
        if (this.sizeField) this.sizeField.hidden = false;
        if (this.priceBlock) this.priceBlock.hidden = !hasSize;
        if (this.buyButtons) this.buyButtons.hidden = !hasSize;
        this.personalizationLocked = !hasSize;
        this.hidden = false;
        this.classList.toggle('is-pick-locked', !hasSize);
        this.setAttribute('aria-disabled', hasSize ? 'false' : 'true');
        this.toggleModeFields();
        this.syncSignature();
      }

      setSizePickerLocked(locked) {
        this.sizeField?.classList.toggle('is-locked', locked);
        this.sizeField?.classList.toggle('is-pick-locked', locked);
        this.sizeField?.setAttribute('aria-disabled', locked ? 'true' : 'false');
        this.sizeInputs.forEach((input) => {
          const unavailable = input.classList.contains('disabled');
          const hideUnavailable = this.jerseyTypeChosen || !locked;
          const label = input.labels?.[0];
          input.disabled = locked || unavailable;
          input.hidden = hideUnavailable && unavailable;
          if (label) label.hidden = hideUnavailable && unavailable;
        });
      }

      setOptionPickerLocked(field, locked) {
        field.classList.toggle('is-pick-locked', locked);
        field.setAttribute('aria-disabled', locked ? 'true' : 'false');
        field.querySelectorAll("input[type='radio']").forEach((input) => {
          input.disabled = locked || input.classList.contains('disabled');
        });
      }

      blockSubmit(message) {
        if (!this.submitButton) return;

        this.submitButton.dataset.jerseyChoiceBlocked = 'true';
        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButton.setAttribute('aria-disabled', 'true');
        if (this.submitButtonText) this.submitButtonText.textContent = message;
      }

      restoreSubmit() {
        if (!this.submitButton || this.submitButton.dataset.jerseyChoiceBlocked !== 'true') return;

        delete this.submitButton.dataset.jerseyChoiceBlocked;
        this.submitButton.removeAttribute('disabled');
        this.submitButton.setAttribute('aria-disabled', 'false');
        if (this.submitButtonText) {
          this.submitButtonText.textContent = this.submitButton.dataset.availableText || this.submitButtonText.textContent;
        }
      }

      refreshColorInputs() {
        this.colorInputs = [...this.variantControlsRoot().querySelectorAll('input[data-option-name]')].filter((input) =>
          this.isColorInput(input)
        );
      }

      variantControlsRoot() {
        return (
          [...this.productRoot.querySelectorAll('variant-selects')].find((node) => node.style.display !== 'none') ||
          this.productRoot.querySelector('variant-selects') ||
          this.productRoot
        );
      }

      isJerseyTypeInput(input) {
        const optionName = input?.dataset?.optionName?.trim().toLowerCase() || '';
        return input.closest("[data-option-role='jersey-type']") || optionName.includes('typ dresu');
      }

      isSizeInput(input) {
        const optionName = input?.dataset?.optionName?.trim().toLowerCase() || '';
        return input.closest('.iamvaclav-size-picker') || optionName.includes('velikost') || optionName.includes('size');
      }

      isColorInput(input) {
        const optionName = input?.dataset?.optionName?.trim().toLowerCase() || '';
        return optionName.includes('barva') || optionName.includes('color') || optionName.includes('colour');
      }

      toggleModeFields() {
        const isCustom = this.isCustom;
        const locked = this.personalizationLocked;

        this.modeInputs?.forEach((input) => {
          input.disabled = locked || input.dataset.jerseyUnavailable === 'true';
        });

        if (this.playerField) this.playerField.hidden = isCustom || !this.hasPlayerOptions;
        if (this.playerSelect) {
          this.playerSelect.disabled = locked || isCustom || !this.hasPlayerOptions;
        }

        if (this.customFields) this.customFields.hidden = !isCustom;
        if (this.customName) this.customName.disabled = locked || !isCustom;
        if (this.customNumber) this.customNumber.disabled = locked || !isCustom;
        if (this.captaincyField) this.captaincyField.hidden = !isCustom;
        this.captaincyInputs?.forEach((input) => {
          input.disabled = locked || !isCustom;
        });
      }

      focusFirstInvalidCustomField() {
        if (!this.nameProperty?.value) {
          this.customName?.focus();
          return this.customName;
        }

        this.customNumber?.focus();
        return this.customNumber;
      }

      validate(event) {
        this.sync();

        const message = this.validationMessage();
        if (!message) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.showError(message);
      }

      validationMessage() {
        const variantChoiceMessage = this.variantChoiceValidationMessage();
        if (variantChoiceMessage) return variantChoiceMessage;

        if (!this.isCustom) {
          if (!this.nameProperty?.value || !this.numberProperty?.value) return 'Vyberte hráče.';
          if (this.numberProperty.value.length > this.numberMaxLength) return this.numberLengthMessage();
        } else {
          if (!this.nameProperty?.value || !this.numberProperty?.value) return 'Vyplňte vlastní jméno a číslo.';
          if (this.nameProperty.value.length > this.nameMaxLength) return this.nameLengthMessage();
          if (this.numberProperty.value.length > this.numberMaxLength) return this.numberLengthMessage();
        }

        return this.signatureValidationMessage();
      }

      variantChoiceValidationMessage() {
        this.refreshVariantChoiceInputs();
        if (!this.jerseyTypeInputs.length || !this.sizeInputs.length) return '';

        if (!this.jerseyTypeChosen || !this.jerseyTypeInputs.some((input) => input.checked && !input.disabled)) {
          this.invalidField = this.jerseyTypeInputs[0];
          return 'Vyberte typ dresu.';
        }

        if (!this.jerseyColorChosen || !this.colorInputs.some((input) => input.checked && !input.disabled)) {
          this.invalidField = this.colorInputs[0];
          return 'Vyberte barvu dresu.';
        }

        if (!this.jerseySizeChosen || !this.sizeInputs.some((input) => input.checked && !input.disabled)) {
          this.invalidField = this.sizeInputs.find((input) => !input.disabled) || this.sizeInputs[0];
          return 'Vyberte velikost.';
        }

        return '';
      }

      signatureValidationMessage() {
        const selectedSignature = this.selectedSignatureInput();
        if (!selectedSignature?.value) return '';
        if (!selectedSignature.dataset.signatureVariantId) return 'Vybraný podpis není dostupný.';
        if (selectedSignature.dataset.signatureRequiresPlayer === 'true' && !this.selectedSignaturePlayerName()) {
          this.invalidField = this.isPlayer ? this.playerSelect : this.signaturePlayerSelect;
          return 'Vyberte hráče pro podpis.';
        }

        return '';
      }

      nameLengthMessage() {
        return `Jméno může mít maximálně ${this.nameMaxLength} znaků.`;
      }

      numberLengthMessage() {
        return `Číslo může mít maximálně ${this.numberMaxLength} znaky.`;
      }

      showError(message) {
        let field = this.invalidField || this.playerSelect;

        if (!this.invalidField && this.isCustom) {
          field = this.focusFirstInvalidCustomField();
        }

        this.error.textContent = message;
        this.error.hidden = false;
        field?.setCustomValidity(message);
        field?.reportValidity();
        field?.focus();
      }

      clearError() {
        this.invalidField = null;
        this.error.textContent = '';
        this.error.hidden = true;
        this.playerSelect?.setCustomValidity('');
        this.signaturePlayerSelect?.setCustomValidity('');
        this.customName?.setCustomValidity('');
        this.customNumber?.setCustomValidity('');
        this.jerseyTypeInputs?.forEach((input) => input.setCustomValidity(''));
        this.colorInputs?.forEach((input) => input.setCustomValidity(''));
        this.sizeInputs?.forEach((input) => input.setCustomValidity(''));
      }
    }
  );
}
